<layout-default>
    <!-- Header section with filters and controls -->
    <div header>
        <!-- Page title -->
        <div toolbar>
            <h4>
                <i-feather name="package"></i-feather> 
                {{ 'Driver Deposit Returns Report' | translate }}
            </h4>
        </div>

        <!-- Date range and report type filters -->
        <div toolbar>
            <div class="label">
                <label>{{ 'Date range' | translate }}:</label>
            </div>
            <div class="input-control" style="flex-grow: 2">
                <date-range-picker
                    [extendedOption]="false"
                    (changedDateRange)="changedDateRange($event)">
                </date-range-picker>
            </div>

            <div class="label">
                <label>{{ 'Report Type' | translate }}:</label>
            </div>
            <div class="input-control">
                <select class="custom-select" [(ngModel)]="queryParams.reportType">
                    <option value="SUMMARY">{{ 'General' | translate }}</option>
                    <option value="DETAILED">{{ 'Extended' | translate }}</option>
                </select>
            </div>
        </div>

        <!-- Depot and return collection filters -->
        <div toolbar>
            <div class="label">
                <label>{{ 'Depots' | translate }}:</label>
            </div>
            <div class="input-control" *ngIf="(depots$ | async)">
                <angular2-multiselect 
                    class="form-control w-40" 
                    [data]="dropdownList"
                    [(ngModel)]="selectedDepots" 
                    [ngModelOptions]="{standalone: true}"
                    [settings]="dropdownSettings">
                </angular2-multiselect>
            </div>

            <div class="label">
                <label>{{ 'Contains Returns' | translate }}:</label>
            </div>
            <div class="input-control">
                <select class="custom-select" [(ngModel)]="queryParams.returnCollected">
                    <option [ngValue]="null">{{ 'All' | translate }}</option>
                    <option [ngValue]="true">{{ 'Yes' | translate }}</option>
                    <option [ngValue]="false">{{ 'No' | translate }}</option>
                </select>
            </div>

            <button 
                class="btn btn-brand-01 mg-l-15" 
                [disabled]="loading"
                (click)="exportReport()">
                <i class="fas fa-download"></i> 
                <span *ngIf="!loading">{{ 'Download Report' | translate }}</span>
                <span *ngIf="loading">{{ 'Loading' | translate }}...</span>
            </button>
        </div>

        <hr />
    </div>

    <!-- Content section with table, empty state, and loading indicator -->
    <div content>
        <!-- Data table - displays first 10 rows preview -->
        <div class="table-container" *ngIf="hasData">
            <div class="table-responsive">
                <ngx-datatable 
                    class="bootstrap" 
                    [rows]="reportData"
                    [columns]="columns" 
                    [columnMode]="'flex'"
                    [headerHeight]="50" 
                    [footerHeight]="0" 
                    [rowHeight]="'auto'"
                    [scrollbarH]="true"
                    [limit]="10">

                    <ng-container *ngFor="let col of columns">
                        <ngx-datatable-column [flexGrow]="col.flexGrow" [prop]="col.prop">
                            <ng-template let-column="column" ngx-datatable-header-template>
                                <span class="tx-bold">{{ col.name }}</span>
                            </ng-template>
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <span>{{ value }}</span>
                            </ng-template>
                        </ngx-datatable-column>
                    </ng-container>
                </ngx-datatable>
            </div>
        </div>

        <!-- Empty state - shown when no data is available -->
        <div class="empty-state" *ngIf="!hasData && !loading">
            <div class="empty-state-content">
                <i class="fas fa-file-csv fa-3x tx-color-03 mg-b-20"></i>
                <p class="tx-color-03">{{ 'Click Download Report button to generate and view data' | translate }}</p>
            </div>
        </div>

        <!-- Loading indicator -->
        <div class="loading-state" *ngIf="loading">
            <div class="spinner-border text-primary" role="status">
                <span class="sr-only">{{ 'Loading' | translate }}...</span>
            </div>
        </div>
    </div>
</layout-default>
